import styled from '@emotion/styled';

export const Container = styled.div`
    padding: 13px;
    width: 250px;
    border-radius: ${({ theme }) => theme.radius.main};
    border: solid 1px ${({ theme }): string => theme.color.grey300};
    background-color: ${({ theme }): string => theme.color.white200};
    display: flex;
    align-items: center;

    &:hover {
        border-color: ${({ theme }): string => theme.color.grey200};
    }

    &:focus-within {
        border-color: ${({ theme }): string => theme.color.grey400};
    }
`;

export const Input = styled.input`
    flex-grow: 1;
    border: none;
    background-color: ${({ theme }): string => theme.color.white200};
    color: ${({ theme }): string => theme.color.black200};

    &:focus {
        outline: none;
    }
`;

export const IconContainer = styled.div`
    flex-grow: 0;
`;
